import { render, staticRenderFns } from "./PortfolioReport.vue?vue&type=template&id=53934d46&scoped=true&"
import script from "./PortfolioReport.vue?vue&type=script&lang=js&"
export * from "./PortfolioReport.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioReport.vue?vue&type=style&index=0&id=53934d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53934d46",
  null
  
)

export default component.exports